<script>
	import { mapActions, mapGetters } from 'vuex';
	import ImageCropper from '@components/ImageCropper.vue';
	import FileUploadBase from '@components/FileUploadBase.vue';

	export default {
		name: 'OnboardingWelcomeDialog',
		components: { FileUploadBase, ImageCropper },
		props: {
			hasLogo: Boolean
		},
		data() {
			return {
				isWelcomeShowing: false,
				isUploading: false,
				droppedFile: null
			};
		},
		methods: {
			...mapActions({
				initializeOnboarding: 'onboardingModule/init',
				uploadLogo: 'uploadLogo',
				markEmployeeAsSeen: 'onboardingModule/setCurrentEmployeeAsSeenWelcome'
			}),
			handleDismiss() {
				this.isWelcomeShowing = false;
				this.markEmployeeAsSeen();
			},
			async handleSubmitLogo(formData) {
				this.isUploading = true;

				const file = formData.get('file');

				const result = await this.uploadLogo(file);

				if (result.isSuccess) {
					await this.markEmployeeAsSeen();
					this.isWelcomeShowing = false;
				}

				this.isUploading = false;
			},
			handleLogoCrop(file) {
				this.$refs.fileUpload.setFiles(file);
			},
			handleCropCancel(previousFile) {
				this.$refs.fileUpload.setFiles(previousFile);
			}
		},
		computed: {
			...mapGetters({
				onboardingInitialized: 'onboardingModule/isInitialized',
				hasNoOnboarding: 'onboardingModule/hasNoOnboarding',
				hasSeenWelcome: 'onboardingModule/hasSeenWelcome',
				loggedInEmployee: 'loggedInEmployee'
			}),
			currentEmployeeHasSeenWelcome() {
				return this.hasSeenWelcome(this.loggedInEmployee.id);
			}
		},
		watch: {
			onboardingInitialized() {
				if (this.hasNoOnboarding || this.hasLogo) return;
				this.isWelcomeShowing = !this.currentEmployeeHasSeenWelcome;
			}
		},
		async created() {
			await this.initializeOnboarding();
		}
	};
</script>

<template>
	<v-dialog v-if="onboardingInitialized" v-model="isWelcomeShowing" max-width="600" persistent>
		<v-card>
			<v-card-title class="headline grey lighten-2">
				Add Your Company Logo
				<v-spacer />
				<v-btn flat icon @click="isWelcomeShowing = false">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>

			<v-card-text>
				<p class="subheading mt-3">Welcome to Your HR System!</p>
				<p>A company logo will personalize your account and make it easily recognisable for your team. Let’s get you set up!</p>

				<file-upload-base
					flat
					ref="fileUpload"
					id="welcomeLogoUpload"
					title="Upload Your Logo"
					accept="image/*"
					:loading="isUploading"
					primary-action="Upload"
					secondary-action="Skip for now"
					hide-title
					hide-file-accept
					@onPrimaryAction="handleSubmitLogo"
					@onSecondaryAction="handleDismiss"
					@droppedFile="droppedFile = $event"
				/>

				<image-cropper
					input-selector="#welcomeLogoUpload input"
					preview-selector="#welcomeLogoUpload .image-preview img"
					:croppie-config="{
						viewport: {
							width: 300,
							height: 125
						}
					}"
					:droppedFile="Array.isArray(droppedFile) && droppedFile.length > 0 ? droppedFile[0] : droppedFile"
					@cropped="handleLogoCrop"
					@cancel="handleCropCancel"
				/>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<style scoped></style>
